import { render } from "./InstallmentsDescriptionBox.vue?vue&type=template&id=33c75fc4"
import script from "./InstallmentsDescriptionBox.vue?vue&type=script&lang=js"
export * from "./InstallmentsDescriptionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__